import { Component, inject, input, output, InputSignal, OutputEmitterRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modalbase',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './modalbase.html',
  styleUrl: './modalbase.scss',
})
export class Modalbase {
  private dialogRef = inject(MatDialogRef<Modalbase>, { optional: true });

  // Inputs using Angular Signals
  title: InputSignal<string> = input<string>('Detalles');
  primaryBtnLabel: InputSignal<string | null> = input<string | null>(null);
  secondaryBtnLabel: InputSignal<string | null> = input<string | null>(null);
  primaryBtnIcon: InputSignal<string | null> = input<string | null>(null);
  secondaryBtnIcon: InputSignal<string | null> = input<string | null>(null);
  primaryBtnDisabled: InputSignal<boolean> = input<boolean>(false);
  secondaryBtnDisabled: InputSignal<boolean> = input<boolean>(false);

  // Outputs using Output Emitters
  close: OutputEmitterRef<void> = output<void>();
  primaryClick: OutputEmitterRef<void> = output<void>();
  secondaryClick: OutputEmitterRef<void> = output<void>();

  onClose(): void {
    this.close.emit();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  onPrimaryClick(): void {
    this.primaryClick.emit();
  }

  onSecondaryClick(): void {
    this.secondaryClick.emit();
  }
}
